import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth'
import type { Role } from '../auth'

interface Props {
  children: React.ReactNode
  /** If specified, only users with one of these roles may access the route. */
  roles?: Role[]
}

export function ProtectedRoute({ children, roles }: Props) {
  const { user, isLoading } = useAuth()
  if (isLoading) {
    return null
  }
  if (user === null) {
    return <Navigate to="/login" replace />
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />
  }
  return <>{children}</>
}
